export interface CustomerSalesInvoiceHistory {
  id: string;
  invoiceNo: number;
  invoiceDate: Date;
  invoicePrice: number;
  invoiceGoodsValue: number;
  invoiceDeliveryValue: number;
  invoiceExtraValue: number;
  invoiceNettValue: number;
  invoiceTaxValue: number;
  invoiceTotalValue: number;
  exchangeRate: number;
  sterlingTotal: number;
  currencyCode: string;
  currencySymbol: string;
  deliveryAddress: string;
}
